import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { approvePlan } from "./api";
import { handlePlanDecisionError, invalidatePlanViews } from "./planRefusal";

// Одобрение плана задачи (AWAITING_PLAN_APPROVAL → PLANNED).
// На успех и на 409 `not_awaiting_plan_approval` перечитываем всё, что
// показывает состояние задачи (`invalidatePlanViews`); на 409 — ещё и
// уведомление.
export function useApprovePlan(
  taskId: string,
): ReturnType<typeof useMutation<void, Error, void>> {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation<void, Error, void>({
    mutationFn: () => approvePlan(taskId),
    onSuccess: () => {
      invalidatePlanViews(queryClient, taskId);
    },
    // Проигрыш гонки (план уже не ждёт решения): перечитывание и
    // уведомление — в `handlePlanDecisionError`.
    onError: (error) => {
      handlePlanDecisionError(queryClient, taskId, error, t);
    },
  });
}
